import React from 'react';
import {Form,Input,Button,Row,Col,Select} from 'antd';
import $ from 'jquery';
const FormItem = Form.Item;

class ForgotPasswordC extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            phoneCaptcha:null,
            phoneCaptchaText:'发送短信验证码',
            companyData:[],
            nextStep:false,
            currentPhone:'',
            token:''
        }
    }
    handleSubmit(e){
        var me = this;
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                tool.sgiLogger.info('Received values of dynamicForm: ', values);

                var Data = JSON.stringify({"body":{'token':me.state.token,"mbl":values.phoneNmb,'Captcha':values.phoneCaptcha},'head':{}});
                $.ajax({
                    url:sgiConfig.registerLogin + '/sms/verify',
                    data:Data,
                    contentType:"application/json;charset=utf-8",
                    type:"post",
                    dataType:"json",
                    success:function(data,state){
                        tool.sgiLogger.info(data,state)
                        if(data.head.code == "00000000" ){
                            me.setState({
                                nextStep:true,
                                currentPhone:values.phoneNmb
                            })

                            var Data = JSON.stringify({body:{mbl:values.phoneNmb},head:{}});
                            $.ajax({
                                url:sgiConfig.registerLogin + '/user/findEpsByMbl',
                                data:Data,
                                contentType:"application/json;charset=utf-8",
                                type:"post",
                                dataType:"json",
                                success:function(data,state){
                                    tool.sgiLogger.info(data,state)
                                    if(data.body.dataset1){
                                        me.setState({
                                            companyData:data.body.dataset1
                                        })
                                    }else{
                                        alert(data.head.msg)
                                    }

                                },
                                error:function(data,state){
                                    tool.sgiLogger.info(data,state)
                                    alert('错误！请重新申请');
                                }
                            });

                        }else{
                            alert('错误！请重新申请');
                        }

                    },
                    error:function(data,state){
                        tool.sgiLogger.info(data,state)
                        alert('错误！请重新申请');
                    }
                });
            }
        });
    }
    changePassword(e){
        var me = this;
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                tool.sgiLogger.info('Received values of dynamicForm: ', values);

                var Data = JSON.stringify({
                    "body": {
                        "userInfo":{
                            "mbl":this.state.currentPhone,
                            "password":values.newPassword
                        },

                        "enterpriseRegisterInfo":{
                            "enterpriseId":values.enterpriseId

                        }
                    },
                    "head": {}
                });
                tool.sgiLogger.info(Data);
                $.ajax({
                    url:sgiConfig.registerLogin + '/password/update ',
                    data:Data,
                    contentType:"application/json;charset=utf-8",
                    type:"post",
                    dataType:"json",
                    success:function(data,state){
                        tool.sgiLogger.info(data,state)
                        if(data.head.code == "00000000" ){
                           alert('密码修改成功')
                            me.props.onCancel()
                        }else{
                            alert('错误！请重新申请');
                        }

                    },
                    error:function(data,state){
                        tool.sgiLogger.info(data,state)
                        alert('错误！请重新申请');
                    }
                });
            }
        });
    }
    sendPhoneCaptcha(){
        var phoneNmb = this.props.form.getFieldValue(['phoneNmb'])['oneNmb'];
        tool.sgiLogger.info(phoneNmb)
        if(!(/^[1][3,4,5,7,8][0-9]{9}$/.test(phoneNmb))){
            alert("不是完整的11位手机号或者正确的手机号");
            return ;
        }
        var me = this;
        me.setState({
            phoneCaptcha:'disabled',
            phoneCaptchaText:'60秒后可以重发'
        });

        var Data = JSON.stringify({"body":{"mbl":phoneNmb},'head':{}});


        $.ajax({
            url:sgiConfig.registerLogin +'/sms/captcha',
            data:Data,
            contentType:"application/json;charset=utf-8",
            type:"post",
            dataType:"json",
            success:function(data,state){
                tool.sgiLogger.info(data,state)
                if(data.head.code == "00000000"){
                    me.setState({
                        token:data.body.token
                    })
                }
            },
            error:function(data,state){
                tool.sgiLogger.info(data,state)
            }
        });


        var time = 60;
        var timeInterval = setInterval(function () {
            time --;
            me.setState({
                phoneCaptchaText:time + '秒后可以重发'
            });
            if(time <= 0){
                clearInterval(timeInterval);
                me.setState({
                    phoneCaptcha:null,
                    phoneCaptchaText:'发送短信验证码'
                });
            }
        },1000);
    }
    handleConfirmPassword = (rule, value, callback) => {
        const { getFieldValue } = this.props.form
        if (value && value !== getFieldValue('newPassword')) {
            callback('两次输入不一致！')
        }

        // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
        callback()
    }
    render(){
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 },
            },
        };
        return (
            <div>
                {
                    this.state.nextStep?
                        <Form onSubmit={this.changePassword.bind(this)}>
                            <FormItem
                                {...formItemLayout}
                                label="请选择公司"
                            >
                                <Row gutter={8}>
                                    <Col span={14}>
                                        {getFieldDecorator('enterpriseId', {
                                            rules: [{ required: true, message: '请选择公司!' }],
                                        })(
                                            <Select  >
                                                {
                                                    this.state.companyData.map(function (item) {
                                                        return  <Option value={item.enterpriseId}>{item.enterpriseName}</Option>
                                                    })
                                                }
                                            </Select>
                                        )}
                                    </Col>
                                </Row>
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="新密码"
                                extra="最少6位，包括至少1个大写字母、1个小写字母、1个数字、1个特殊字符(!@#$%^&*)"
                            >
                                <Row gutter={8}>
                                    <Col span={14}>
                                        {getFieldDecorator('newPassword', {
                                            rules: [{ required: true, message: '新密码不能为空!' },{pattern:/^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/,message: '密码强度过底!'}],
                                        })(
                                            <Input type='password'/>
                                        )}
                                    </Col>
                                </Row>
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="确认新密码"
                            >
                                <Row gutter={8}>
                                    <Col span={14}>
                                        {getFieldDecorator('confirmNewPassword', {
                                            rules: [{ required: true, message: '确认新密码不能为空!' },{validator: this.handleConfirmPassword,message: '确认密码错误!'}],
                                        })(
                                            <Input type='password'/>
                                        )}
                                    </Col>
                                </Row>
                            </FormItem>
                            <div>
                                <Button style={{marginLeft:'118px'}} type={'primary'} htmlType="submit" >确定</Button>
                            </div>
                        </Form>:
                        <Form onSubmit={this.handleSubmit.bind(this)} >
                            <FormItem
                                {...formItemLayout}
                                label="手机号码"
                            >
                                <Row gutter={8}>
                                    <Col span={14}>
                                        {getFieldDecorator('phoneNmb', {
                                            rules: [{ required: true, message: '手机号码不能为空!' },{pattern:/^[1][3,4,5,7,8][0-9]{9}$/,message: '请输入正确的电话号码!'}],
                                        })(
                                            <Input />
                                        )}
                                    </Col>
                                </Row>
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="短信验证码"
                            >
                                <Row gutter={8}>
                                    <Col span={14}>
                                        {getFieldDecorator('phoneCaptcha', {
                                            rules: [{ required: true, message: '请填写手机验证码!' }],
                                        })(
                                            <Input />
                                        )}
                                    </Col>
                                    <Col span={10}>
                                        <Button type={'primary'} disabled={this.state.phoneCaptcha} onClick={this.sendPhoneCaptcha.bind(this)}>{this.state.phoneCaptchaText}</Button>
                                    </Col>
                                </Row>
                            </FormItem>
                            <div>
                                <Button style={{marginLeft:'118px'}} type={'primary'} htmlType="submit" >确定</Button>
                            </div>
                        </Form>
                }
            </div>
        )
    }
}

const ForgotPassword = Form.create()(ForgotPasswordC);
export default ForgotPassword


// WEBPACK FOOTER //
// ./apps/pages/login/ForgotPassword.js